export enum NotificationType {
    User
}